
<dashboard-card [title]="'Call Status'" [soFarAchieved]="totalCall" [dataItems]="dataItems"></dashboard-card>